"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lockBody = () => {
    document.body.classList.add("overflow-hidden");
};
const unlockBody = () => {
    document.body.classList.remove("overflow-hidden");
};
function useScrollBehaviourBody() {
    return {
        lockBody,
        unlockBody,
    };
}
exports.default = useScrollBehaviourBody;
